
        var result = require("!!../../css-loader/dist/cjs.js!./material.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    